import {
  languageChangeListener
} from "./chunk-HLNUYU7W.mjs";
import {
  relatedDomainsLinkListener
} from "./chunk-IR3NM2F5.mjs";

// src/listeners/index.ts
function setupListeners() {
  const cleanupLanguageObserver = languageChangeListener();
  const cleanupRelatedDomainsLinkListener = relatedDomainsLinkListener();
  return () => {
    cleanupLanguageObserver();
    cleanupRelatedDomainsLinkListener();
  };
}

export {
  setupListeners
};
